import * as services from 'utils/services';       // eslint-disable-line
import _ from 'lodash';                           // eslint-disable-line



export const submitLogin = (payload, formikActions) => async (dispatch) => {
  return dispatch({ type: 'SUBMIT_LOGIN', value: payload, formikActions });
};
